var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"width":_vm.iconSize,"height":_vm.iconSize,"icon-color":"transparent","view-box":"0 0 24 24"}},[_c('IconPointDefaultPath',{attrs:{"bg-color":_vm.bgColor,"icon-color":_vm.iconColor,"border-color":_vm.borderColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }